/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, {useState} from 'react';
import { IObrienModalWindowViewProps } from './obrien-modal-window';

import { Modal, ModalHeader, ModalBody } from 'reactstrap';

export default (props: IObrienModalWindowViewProps) => {

    

    const { 
        modalTitle, 
        modalContent, 
        modalImage,
        //@ts-ignore
        buttonLabel, className,
        modalButtonLink,
        modalButtonText
        
    } = props;

    const [modal, setModal] = useState(true);

    const toggle = () => setModal(!modal);


    return (

    <div>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
        <ModalBody className="flex-md">
            <div className="forty">{modalImage}</div>
            <div className="sixty">
                {modalContent}
                {modalButtonLink ? (
                    <a className="btn btn-primary" href={modalButtonLink}>{modalButtonText}</a>
                ) : null}
            </div>
         </ModalBody>
      </Modal>
    </div>


       
    );
};
